import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/api";


// Get all runners
export const fetchAllRunners = createAsyncThunk(
  "runners/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/runners/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateProfile = createAsyncThunk("runners/updateProfile", async (profileData, { rejectWithValue }) => {
  console.log("profile data", profileData)
  try {
    const res = await api.put('/runners/update-runner-profile', profileData);

    console.log("updating runner profile", profileData)
    return res.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Get runners by service type
export const fetchRunnersByService = createAsyncThunk(
  "runners/fetchByService",
  async (serviceType, { rejectWithValue }) => {
    try {
      const response = await api.get(`/runners/service/${serviceType}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchRecentChatHistory = createAsyncThunk(
  "runners/fetchRecentChatHistory",

  async (runnerId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/runners/chat/${runnerId}/recent-chats`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
)

export const fetchRefreshRecentChats = createAsyncThunk(
  "runners/fetchRefreshRecentChatHistory",

  async (runnerId, { rejectWithValue }) => {
    try {
      const response = await api.post(`/runners/chat/${runnerId}/refresh-recent-chats`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
)

// Get nearby runners
export const fetchNearbyRunners = createAsyncThunk(
  "runners/fetchNearby",
  async ({
    latitude, longitude,
    deliveryLat, deliveryLng,
    fleetType,
    firstName, lastName,
    sortBy,

  }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({
        latitude: latitude.toString(),
        longitude: longitude.toString(),
      });


      if (fleetType) params.append("fleetType", fleetType);
      if (sortBy) params.append("sortBy", sortBy);
      if (deliveryLat) params.append("deliveryLat", deliveryLat.toString());
      if (deliveryLng) params.append("deliveryLng", deliveryLng.toString());

      const response = await api.get(`/runners/nearby-runners?${params.toString()}`);
      // console.log('Fetched Nearby Runners:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching nearby runners:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Get online runners
export const fetchOnlineRunners = createAsyncThunk(
  "runners/fetchOnline",
  async ({ serviceType, fleetType } = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      if (serviceType) params.append("serviceType", serviceType);
      if (fleetType) params.append("fleetType", fleetType);

      // console.log('serviceType being fetched', serviceType);

      const queryString = params.toString();
      const response = await api.get(`/runners/online${queryString ? `?${queryString}` : ""}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update runner location
export const updateRunnerLocation = createAsyncThunk(
  "runners/updateLocation",
  async ({ userId, latitude, longitude }, { rejectWithValue }) => {
    try {
      const response = await api.post("/runners/update-location", {
        userId,
        latitude,
        longitude,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Set runner online status
export const setRunnerOnlineStatus = createAsyncThunk(
  "runners/setOnlineStatus",
  async ({ userId, isOnline, isAvailable }, { rejectWithValue }) => {
    try {
      const response = await api.post("/runners/set-online-status", {
        userId,
        isOnline,
        isAvailable,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const getProfile = createAsyncThunk("runners/getProfile", async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/runners/profile');
    return res.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});


const runnerSlice = createSlice({
  name: "runners",
  initialState: {
    runners: [],
    nearbyRunners: [],
    onlineRunners: [],
    selectedRunner: null,
    count: 0,
    loading: false,
    error: null,
  },
  reducers: {
    clearRunners: (state) => {
      state.runners = [];
      state.nearbyRunners = [];
      state.onlineRunners = [];
      state.count = 0;
      state.error = null;
    },
    setSelectedRunner: (state, action) => {
      state.selectedRunner = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Update profile
    builder
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.runners = action.payload.runners;
        state.count = action.payload.count;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
    builder
      // Fetch all runners
      .addCase(fetchAllRunners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllRunners.fulfilled, (state, action) => {
        state.loading = false;
        state.runners = action.payload.runners;
        state.count = action.payload.count;
      })
      .addCase(fetchAllRunners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      // Fetch by service type
      .addCase(fetchRunnersByService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRunnersByService.fulfilled, (state, action) => {
        state.loading = false;
        state.runners = action.payload.runners;
        state.count = action.payload.count;
      })
      .addCase(fetchRunnersByService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      // Fetch nearby runners
      .addCase(fetchNearbyRunners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNearbyRunners.fulfilled, (state, action) => {
        state.loading = false;
        state.nearbyRunners = action.payload.runners;
        state.count = action.payload.count;
      })
      .addCase(fetchNearbyRunners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      .addCase(fetchRecentChatHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecentChatHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.recentChatHistory = action.payload.data;
      })

    builder
      .addCase(fetchRefreshRecentChats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRefreshRecentChats.fulfilled, (state, action) => {
        state.loading = false;
        state.recentChats = action.payload.data?.chats || action.payload.data || [];
      })

    builder
      // Fetch online runners
      .addCase(fetchOnlineRunners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOnlineRunners.fulfilled, (state, action) => {
        state.loading = false;
        state.onlineRunners = action.payload.runners;
        state.count = action.payload.count;
      })
      .addCase(fetchOnlineRunners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload.data?.runner || action.payload.runner || action.payload.data;
      })

    builder
      // Update location
      .addCase(updateRunnerLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRunnerLocation.fulfilled, (state, action) => {
        state.loading = false;
        // Update runner in the list if exists
        const updatedRunner = action.payload.runner;
        state.runners = state.runners.map((r) =>
          r._id === updatedRunner._id ? { ...r, ...updatedRunner } : r
        );
      })
      .addCase(updateRunnerLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    builder
      // Set online status
      .addCase(setRunnerOnlineStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(setRunnerOnlineStatus.fulfilled, (state, action) => {
        state.loading = false;
        const updatedRunner = action.payload.runner;
        state.runners = state.runners.map((r) =>
          r._id === updatedRunner._id ? { ...r, ...updatedRunner } : r
        );
      })
      .addCase(setRunnerOnlineStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearRunners, setSelectedRunner, clearError } = runnerSlice.actions;
export default runnerSlice.reducer;